import { Input } from "antd";
import {
  AiOutlineEnvironment,
  AiOutlinePhone,
  AiOutlineMobile,
  AiOutlineMail,
  AiOutlineShop,
  AiOutlineSafetyCertificate,
  AiOutlineContacts,
  AiOutlineUserAdd,
  AiOutlineUser,
  AiOutlineLaptop,
} from "react-icons/ai";
import styled from "styled-components";
import { AppPartType } from "../../../types";
import { FC } from "react";
import { APP_PART_TYPES } from "../../../constants";

const Styles = styled.div<{ $iconColor?: string }>`
  display: flex;

  .branch-icon {
    display: flex;
    align-items: center;
    background: ${(props) => props.$iconColor || "#174a83"};
    padding: 0 5px;
    border: 0.5px solid #f7f9fa;
    border-radius: 3px;
  }

  .ant-input-wrapper,
  .ant-btn-icon-only,
  .ant-input-wrapper {
    height: 100%;
  }

  input {
    height: 100%;
  }
`;

const APP_PART_TYPE_ICONS = {
  [APP_PART_TYPES.WORKER_ADDRESSES_SELECTION]: AiOutlineEnvironment,
  [APP_PART_TYPES.WORKER_PHONE_NUMBERS_LANDLINE_SELECTION]: AiOutlinePhone,
  [APP_PART_TYPES.WORKER_PHONE_NUMBERS_MOBILE_SELECTION]: AiOutlineMobile,
  [APP_PART_TYPES.USER_WORKER_EMAILS_SELECTION]: AiOutlineMail,
  [APP_PART_TYPES.WORKER_STORES_SELECTION]: AiOutlineShop,
  [APP_PART_TYPES.WORKER_REGISTRATION_NUMBERS_SELECTION]:
    AiOutlineSafetyCertificate,
  [APP_PART_TYPES.WORKER_EMERGENCY_CONTACTS_SELECTION]: AiOutlineContacts,
  [APP_PART_TYPES.WORKER_EMERGENCY_ADDRESSES_SELECTION]: AiOutlineEnvironment,
  [APP_PART_TYPES.WORKER_ONBOARDINGS_SELECTION]: AiOutlineUserAdd,
  [APP_PART_TYPES.WORKER_INSURANCES_REGULAR_INSURANCE_SELECTION]:
    AiOutlineSafetyCertificate,
  [APP_PART_TYPES.WORKER_INSURANCES_UNEMPLOYMENT_INSURANCE_SELECTION]:
    AiOutlineSafetyCertificate,
  [APP_PART_TYPES.WORKER_COMPANY_EMAILS_SELECTION]: AiOutlineMail,
  [APP_PART_TYPES.WORKER_DEVICES_SELECTION]: AiOutlineLaptop,
};

type PropsType = {
  appPart: AppPartType;
};

const EmployeeInfoChildSelection: FC<PropsType> = ({ appPart }) => {
  const Icon =
    APP_PART_TYPE_ICONS[
      appPart.app_part_type as keyof typeof APP_PART_TYPE_ICONS
    ] || AiOutlineUser;
  const iconColor = appPart.item_config_data?.employee_info_color || "#174a83";

  return (
    <Styles
      style={{ height: "100%", maxHeight: "42px" }}
      $iconColor={iconColor}
    >
      <Input.Search disabled />

      <div className="branch-icon">
        <Icon size={20} color="#fff" />
      </div>
    </Styles>
  );
};

export default EmployeeInfoChildSelection;
